import { useState } from "react";
import { useNavigate } from "react-router-dom";
import apiClient from "../Api/apiConfig";
// import { useAuth } from "../lib/auth"; // plus nécessaire ici pour le reset

export default function ForgotPassword() {
  const [step, setStep] = useState(1);
  const [email, setEmail] = useState("");
  const [inputCode, setInputCode] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  // ÉTAPE 1 : Demander le code (inchangé)
  const handleSendEmail = async (e) => {
    e.preventDefault();
    setSuccessMessage("");
    setErrorMessage("");
    setLoading(true);

    try {
      await apiClient.post("/users/forgot-password", { email });
      setSuccessMessage("✅ Un code à 6 chiffres a été envoyé sur votre email.");
      setStep(2);
    } catch (error) {
      setErrorMessage(error.response?.data?.error || "❌ Impossible d'envoyer l'email.");
    } finally {
      setLoading(false);
    }
  };

  // ÉTAPE 2 : Vérifier le code puis rediriger vers ResetPassword
  const handleVerifyCode = async (e) => {
    e.preventDefault();
    setSuccessMessage("");
    setErrorMessage("");
    setLoading(true);

    try {
      // 👉 On appelle désormais la route dédiée au reset
      const response = await apiClient.post("/users/verify-code-reset", {
        email,
        code: inputCode,
      });

      const resetToken = response.data.resetPasswordToken;
      if (!resetToken) {
        throw new Error("Token de réinitialisation manquant.");
      }

      setSuccessMessage("✅ Code valide ! Vous pouvez maintenant choisir un nouveau mot de passe.");

      // 👉 Redirection vers ResetPassword.jsx avec le token dans l’URL
      // et l’email dans la query pour pré-remplir
      navigate(
        `/reset-password/${encodeURIComponent(resetToken)}?email=${encodeURIComponent(email)}`
      );
    } catch (error) {
      console.error(error);
      setErrorMessage(error.response?.data?.error || "❌ Code invalide ou expiré.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="forgot-password-page">
      <h2>{step === 1 ? "Mot de passe oublié" : "Vérification du code"}</h2>

      {successMessage && <p className="success-message">{successMessage}</p>}
      {errorMessage && <p className="error-message">{errorMessage}</p>}

      {step === 1 && (
        <form onSubmit={handleSendEmail}>
          <div className="form-group">
            <label htmlFor="email">Adresse email</label>
            <input
              type="email"
              id="email"
              placeholder="Entrez votre adresse email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              disabled={loading}
            />
          </div>
          <button type="submit" className="submit-button" disabled={loading}>
            {loading ? "Envoi..." : "Recevoir le code"}
          </button>
        </form>
      )}

      {step === 2 && (
        <form onSubmit={handleVerifyCode}>
          <div className="form-group">
            <label htmlFor="code">Code reçu par email</label>
            <input
              type="text"
              id="code"
              placeholder="Ex: 123456"
              value={inputCode}
              onChange={(e) => setInputCode(e.target.value)}
              required
              maxLength={6}
              className="code-input"
              disabled={loading}
            />
          </div>

          <button type="submit" className="submit-button" disabled={loading}>
            {loading ? "Vérification..." : "Valider le code"}
          </button>

          <p
            className="resend-link"
            onClick={() => setStep(1)}
            style={{
              marginTop: "10px",
              cursor: "pointer",
              color: "#666",
              fontSize: "0.9em",
              textDecoration: "underline",
            }}
          >
            Ce n&apos;est pas le bon email ? Recommencer.
          </p>
        </form>
      )}
    </div>
  );
}
